/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { FIND } from './mutation-types';
export default {

  [FIND](state, account) {
    state.id = account.id
    state.email = account.email
    state.name = account.name
    state.screen_name = account.screen_name
    state.country = account.country
    state.lang = account.lang
    state.icon_img = account.icon_img
    state.prefecture = account.prefecture
    state.prefecture_kanji = account.prefecture_kanji
    state.post_code = account.post_code
    state.address = account.address
    state.address_kanji = account.address_kanji
    state.first_name = account.first_name
    state.last_name = account.last_name
    state.first_name_kanji = account.first_name_kanji
    state.last_name_kanji = account.last_name_kanji
    state.street = account.street
    state.street_kanji = account.street_kanji
    state.line1 = account.line1
    state.line1_kanji = account.line1_kanji
    state.line2 = account.line2
    state.line2_kanji = account.line2_kanji
    state.stripe_id = account.stripe_id
    state.stripe_pub_key = account.stripe_pub_key
    state.stripe_secret_key = account.stripe_secret_key
    localStorage.setItem('nerzex.user', JSON.stringify(account))
  },

}
